import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, ListItem, RefreshIndicator, Avatar } from 'material-ui';
import { any, either, prop, isEmpty, isNil, not, equals, and, path, merge } from 'ramda';
import Select from 'react-select';
import { countries, howTheyHeard as howTheyHeardOptions } from '../../../utils/select-fields';
import PageInDicatorDots from '../page-indicator-dots';
import ProfileImage from '../../app-bar/profile-image';
import debounce from 'lodash.debounce';
import { SmallFlatButton } from '../../tc-ui/small-buttons';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import SignUpError from './error';
import { isValidEmail } from '../../../utils/validations';

const isEmptyOrNil = either(isEmpty, isNil);

const FormContainer = props => {
  const {
    dispatchedUpdateProps,
    country,
    howTheyHeard,
    companyName,
    email,
    password,
    numOfIndicatorDots,
    checkCompanyName,
    foundExistingCompanyInfo,
    searchSpinner,
    showFoundExistingCompanyInfo,
    submitSignUpAction,
    companyTypeChecked,
    selectedCompanyType,
    acctCreationReason,
    oneOrMultiProperties,
    numOfProperties,
    oneOrMultiCities,
    existingCompanyId,
    selectedCompany,
    showExistingCompanyDialog,
    goToConfirmationPage,
    signUpError,
    showSignUpError,
    creatingUser,
    signup,
    region,
  } = props;

  const textFieldInfo = [
    {
      label: 'Email',
      inputKey: 'email',
    },
    {
      label: 'Password',
      inputKey: 'password',
      errorText: 'Password must be at least 6 characters long.',
    },
  ];

  const fieldsToCheck = [isEmptyOrNil(companyName), isEmptyOrNil(email), isEmptyOrNil(country), not(isValidEmail(email)), isEmptyOrNil(password), isEmptyOrNil(howTheyHeard), path(['length'], password) < 6];

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'inline-block', maxWidth: '660px' }}>
        <h3 style={{ fontWeight: '300', textAlign: 'left', color: 'rgba(0, 0, 0, 0.87)', fontSize: '24px' }}>Please create your account now, and we'll use your answers to guide you through the system as you get started.</h3>
        <div style={{ maxWidth: '410px', margin: '0 auto' }}>
          <div style={{ marginBottom: '14px' }}>
            <p style={{ textAlign: 'left', marginBottom: '0px' }}><span style={{ color: '#4bbcd9' }}>*</span><span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> Country</span></p>
            <Select
              className="countriesServed"
              name="countriesServed"
              scrollMenuIntoView={false}
              options={countries}
              clearable={false}
              placeholder=""
              value={country}
              onChange={({ value }) => dispatchedUpdateProps({ country: value })}
            />
          </div>
          <div style={{ width: '110%', marginBottom: '14px' }} className="Grid companyName">

            {
              existingCompanyId && selectedCompany ? (
                <div
                  style={{
                    maxHeight: '200px',
                    overflowY: 'scroll',
                    width: '410px',
                    border: '1px solid #afaaaa',
                    padding: '16px',
                    backgroundColor: 'white',
                  }}
                >
                  <div className="flex-tc-sb" style={{ marginBottom: '8px' }}>
                    <span>You are joining the company below.</span>
                    <SmallFlatButton
                      style={{ border: '1px solid #00bcd4' }}
                      labelStyle={{ color: '#00bcd4', padding: '0 4px' }}
                      label="Change Company"
                      onTouchTap={() => dispatchedUpdateProps({ selectedCompany: null, existingCompanyId: null, companyName: '' })}
                    />
                  </div>
                  <div
                    className="flex-center"
                  >
                    {
                      selectedCompany.profileImageUrl ? (
                          <Avatar src={selectedCompany.profileImageUrl}/>
                        ) : (<Avatar>{(selectedCompany.companyName || '')[0] || ''}</Avatar>)
                    }
                    <span style={{ marginLeft: '10px' }}>
                        <span style={{ fontWeight: '600' }}>{selectedCompany.companyName}</span>
                        <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}> - {selectedCompany.country}</span>
                      </span>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ float: 'left', minWidth: '410px' }}>
                    <p style={{ textAlign: 'left', marginBottom: '0px' }}>
                      <span style={{ color: '#4bbcd9' }}>*</span>
                      <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> Company Name</span>
                    </p>
                    <TextField
                      autoComplete="off"
                      id="companyName"
                      fullWidth
                      underlineShow={false}
                      style={{ border: '1px solid #d8d8d8', borderRadius: '3px', height: '40px', backgroundColor: '#ffffff' }}
                      inputStyle={{ padding: '0 5px' }}
                      onChange={({ target: { value } }) => {
                        dispatchedUpdateProps({ companyName: value });
                        debounce(checkCompanyName, 100)();
                      }}
                      value={companyName}
                    />
                  </div>
                  <div style={{ float: 'right', position: 'relative' }} className="Grid-cell Grid-cell--center">
                    <RefreshIndicator
                      size={25}
                      left={0}
                      top={5}
                      status={searchSpinner}
                    />
                  </div>
                </div>
              )
            }
            {
              showFoundExistingCompanyInfo &&
              Array.isArray(foundExistingCompanyInfo) &&
              foundExistingCompanyInfo.length > 0 ?
                <div style={{ marginTop: '16px' }}>
                  {'Continue entering your company name to create a new account.'}
                  <div style={{ textAlign: 'center' }}>OR</div>
                  <div
                    style={{
                      maxHeight: '200px',
                      overflowY: 'scroll',
                      width: '410px',
                      border: '1px solid #afaaaa',
                      padding: '16px',
                      backgroundColor: 'white',
                    }}
                  >
                    <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                      {'Select your company below to be added to an existing account.'}
                    </div>
                    {
                      foundExistingCompanyInfo.map((existingCompany, i, arr) => {
                        return (
                          <div
                            key={i}
                            className="flex-tc-sb"
                            style={{ backgroundColor: '#f4f6fa', padding: '8px', borderBottom: i < arr.length - 1 ? '1px solid #cacdd4' : '' }}
                          >
                            <div className="flex-center">
                              {
                                existingCompany.profileImageUrl ? (
                                  <Avatar src={existingCompany.profileImageUrl}/>
                                ) : (<Avatar>{(existingCompany.companyName || '')[0] || ''}</Avatar>)
                              }
                              <span style={{ marginLeft: '10px' }}>
                          <span style={{ fontWeight: '600' }}>{existingCompany.companyName}</span>
                          <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}> - {existingCompany.country}</span>
                        </span>
                            </div>
                            <SmallFlatButton
                              style={{ border: '1px solid #00bcd4' }}
                              labelStyle={{ color: '#00bcd4', padding: '8px' }}
                              label="Join"
                              onTouchTap={() => dispatchedUpdateProps({
                                selectedCompany: existingCompany,
                                companyName: existingCompany.companyName,
                                existingCompanyId: existingCompany.companyId,
                                showFoundExistingCompanyInfo: false,
                              })}
                            />
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              : <span/>
            }
          </div>
          <div style={{ marginBottom: '14px' }} className="howTheyHeard">
            <p style={{ textAlign: 'left', marginBottom: '0px' }}><span style={{ color: '#4bbcd9' }}>*</span><span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> How did you hear about TourConnect?</span></p>
            <Select
              name="howTheyHeard"
              scrollMenuIntoView={false}
              options={howTheyHeardOptions}
              clearable={false}
              placeholder=""
              value={howTheyHeard}
              onChange={({ value }) => dispatchedUpdateProps({ howTheyHeard: value })}
            />
          </div>
          {
            textFieldInfo.map((textItem, index) => {
              return (
                <div style={{ clear: 'both', marginBottom: '14px' }} key={index} className={`SignUp-${textItem.inputKey}`}>
                  <p style={{ textAlign: 'left', marginBottom: '0px' }}>
                    <span style={{ color: '#4bbcd9' }}>*</span>
                    <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> {prop('label', textItem)}</span>
                  </p>
                  <TextField
                    fullWidth
                    id={textItem.inputKey}
                    underlineShow={false}
                    style={{ border: '1px solid #d8d8d8', borderRadius: '3px', height: '40px', backgroundColor: '#ffffff' }}
                    inputStyle={{ padding: '0 5px' }}
                    type={equals(prop('inputKey', textItem), 'password') ? prop('inputKey', textItem) : 'text'}
                    onChange={({ target: { value } }) => {
                      if (showSignUpError) {
                        dispatchedUpdateProps({
                          [prop('inputKey', textItem)]: value,
                          showSignUpError: false,
                          signUpError: '',
                          creatingUser: false,
                        });
                      }
                      dispatchedUpdateProps({ [prop('inputKey', textItem)]: value });
                    }}
                    errorText={textItem.errorText && password.length && password.length < 6 ? textItem.errorText : ''}
                    errorStyle={{ marginTop: '1%' }}
                    value={props[prop('inputKey', textItem)]}
                    disabled={equals(textItem.inputKey, 'email') && not(isEmptyOrNil(signup.MMCompanyToView))}
                  />
                </div>
              );
            })
          }
        </div>
        <RaisedButton
          secondary
          id="createAccountRaisedButton"
          label="CREATE ACCOUNT"
          style={{ height: '48px', width: '410px', marginTop: '7%' }}
          labelStyle={{ fontWeight: 'bold', top: '12px' }}
          disabled={any(equals(true))(fieldsToCheck)}
          loader={creatingUser}
          onTouchTap={() => {
            const infoToSend = {
              companyTypeChecked,
              selectedCompanyType,
              acctCreationReason: not(isEmptyOrNil(signup.MMCompanyToView)) ? 'MMShell' : acctCreationReason,
              country,
              howTheyHeard,
              companyName,
              email,
              password,
              oneOrMultiProperties,
              numOfProperties,
              oneOrMultiCities,
              existingCompanyId,
              foundExistingCompanyInfo,
              region,
            };
            if (existingCompanyId) dispatchedUpdateProps({ showExistingCompanyDialog: true, signUpError: 'COMPANY', showSignUpError: true });
            else {
              submitSignUpAction(not(isEmptyOrNil(signup.MMCompanyToView)) ? merge(infoToSend, {
                forMMShell: true,
              }) : infoToSend);
            }
          }}
        />
        {
          showSignUpError ?
            <SignUpError
              error={signUpError}
              showExistingCompanyDialog={showExistingCompanyDialog}
              dispatchedUpdateProps={dispatchedUpdateProps}
              goToConfirmationPage={goToConfirmationPage}
              companyName={companyName}
              submitSignUpAction={submitSignUpAction}
              companyTypeChecked={companyTypeChecked}
              selectedCompanyType={selectedCompanyType}
              acctCreationReason={acctCreationReason}
              country={country}
              email={email}
              password={password}
              oneOrMultiProperties={oneOrMultiProperties}
              numOfProperties={numOfProperties}
              oneOrMultiCities={oneOrMultiCities}
              existingCompanyId={existingCompanyId}
              region={region}
            /> : <span/>
        }
        <PageInDicatorDots
          numberOfIndicators={numOfIndicatorDots}
          activeIndicator={numOfIndicatorDots + 1}
        />
        <p style={{ color: 'rgba(0, 0, 0, 0.3)', fontSize: '14px', marginTop: '5%' }}>
          Please fill out all required (<span style={{ color: '#4bbcd9' }}>*</span>) fields.
        </p>
        <div style={{ width: '410px', margin: '0 auto' }} className="Grid">
          <p className="Grid-cell Grid-cell--center" style={{ color: 'rgba(0, 0, 0, 0.3)', fontSize: '14px', maxWidth: '384px', display: 'inline-block', marginTop: '2%' }}>
            By clicking "CREATE ACCOUNT", you agree to TourConnect's <a href="http://www.tourconnect.com/terms-of-service/" target="_blank" style={{ color: '#4bbcd9' }}>Terms and Conditions</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

FormContainer.propTypes = {
  dispatchedUpdateProps: PropTypes.func,
  country: PropTypes.string,
  companyName: PropTypes.string,
  email: PropTypes.string,
  howTheyHeard: PropTypes.string,
  password: PropTypes.string,
  numOfIndicatorDots: PropTypes.number,
  checkCompanyName: PropTypes.func,
  foundExistingCompanyInfo: PropTypes.array,
  searchSpinner: PropTypes.string,
  showFoundExistingCompanyInfo: PropTypes.bool,
  submitSignUpAction: PropTypes.func,
  companyTypeChecked: PropTypes.array,
  selectedCompanyType: PropTypes.string,
  acctCreationReason: PropTypes.string,
  oneOrMultiProperties: PropTypes.string,
  numOfProperties: PropTypes.string,
  oneOrMultiCities: PropTypes.string,
  existingCompanyId: PropTypes.string,
  showExistingCompanyDialog: PropTypes.bool,
  goToConfirmationPage: PropTypes.func,
  signUpError: PropTypes.string,
  creatingUser: PropTypes.bool,
  showSignUpError: PropTypes.bool,
  signup: PropTypes.object,
  region: PropTypes.string,
};

const mapStateToProps = state => ({
  signup: state.signup.toJS(),
});

export default connect(mapStateToProps)(FormContainer);



// WEBPACK FOOTER //
// ./src/app/components/signup/form/form-container.jsx